var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribblesPeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 51,
    viewBox: "0 0 80 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4696 18.5714C57.4696 18.5714 74.039 13.6793 76.1315 15.2357C78.224 16.7922 72.1278 34.0048 72.1278 34.0048L69.0762 43H13.4871C12.8689 41.4878 12.4959 39.9759 12.4511 38.4953L16.5277 16.919C16.5277 16.919 18.295 1.21935 20.57 0.315301C22.8449 -0.588752 34.8854 12.8163 34.8854 12.8163C39.9687 12.6248 45.2629 12.9491 49.5045 14.4045C52.1271 15.3043 54.85 16.809 57.4696 18.5714Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5788 32.3303C36.4927 35.0904 34.3413 32.2604 31.5813 32.1743C28.8212 32.0881 26.4975 34.7783 26.5837 32.0183C26.6699 29.2582 28.9304 28.5898 31.6905 28.676C34.4505 28.7621 36.665 29.5702 36.5788 32.3303Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7968 40.1548C55.4566 42.5692 54.8396 39.0684 52.4252 37.7281C50.0108 36.3879 46.7134 37.7158 48.0536 35.3014C49.3938 32.887 51.7095 33.3277 54.1239 34.668C56.5383 36.0082 58.1371 37.7405 56.7968 40.1548Z",
    fill: "#3D3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 41.8742C39.7826 42.4563 40.5357 42.6201 41.035 42.2084L44.7974 39.1057C45.4415 38.5745 45.1896 37.5346 44.3738 37.3571L38.4784 36.0743C37.6626 35.8967 37.0013 36.738 37.3665 37.4888L39.4995 41.8742Z",
    fill: "#C5AAAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4544 22.4575L53.4366 15.4871L57.6196 18.1767L52.4544 22.4575Z",
    fill: "#676767"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5706 18.8312L34.6143 12.3229L39.5876 12.3227L37.5706 18.8312Z",
    fill: "#676767"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8002 25.176L51.7867 15.0667C51.7867 15.0667 48.8854 13.9085 46.7455 13.3912C44.6056 12.8739 40.8275 12.4173 40.8275 12.4173L43.8002 25.176Z",
    fill: "#676767"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3484 40.8092C77.22 37.108 72.3753 31.1607 67.1263 31.3428C61.8774 31.5249 58.2119 37.7674 58.3403 41.4686C58.4687 45.1697 65 45 68.5 45C71 45 77.4768 44.5103 77.3484 40.8092Z",
    fill: "#969696"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0951 40.8092C3.2235 37.108 8.06819 31.1607 13.3171 31.3428C18.5661 31.5249 22.2316 37.7674 22.1032 41.4686C21.9748 45.1697 14.5 45.0867 12 45C9.5 44.9133 2.9667 44.5103 3.0951 40.8092Z",
    fill: "#969696"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 56,
    y: 31,
    width: 23.4834,
    height: 19.3604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0.960602,
    y: 31,
    width: 23.4829,
    height: 19.3458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 42.5,
    y1: 24,
    x2: 41,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribblesPeek);
export default __webpack_public_path__ + "static/media/scribbles-peek.53fc44a29f26985daf9e834a195b4543.svg";
export { ForwardRef as ReactComponent };